import { render, staticRenderFns } from "./monthly-harvest-size-distribution.vue?vue&type=template&id=0b9bbf26&scoped=true&"
import script from "./monthly-harvest-size-distribution.vue?vue&type=script&lang=js&"
export * from "./monthly-harvest-size-distribution.vue?vue&type=script&lang=js&"
import style0 from "./monthly-harvest-size-distribution.vue?vue&type=style&index=0&id=0b9bbf26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9bbf26",
  null
  
)

export default component.exports